import React from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { IconButton } from "components"
import classes from "./OfflineOrderDetailCancelButton.module.scss"

const OfflineOrderDetailCancelButton = props => {
  const { setShowConfirmationModal } = props

  const [t, i18n] = useTranslation()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={classes["container"]}
      onClick={() => setShowConfirmationModal(true)}
    >
      <IconButton
        color="var(--color-danger)"
        icon={MdClose}
        size={18}
      />
      <span
        className={clsx(
          classes["text"],
          isLtr && classes["text-ltr"]
        )}
      >
        {t("لغو_سفارش")}
      </span>
    </div>
  )
}

export default OfflineOrderDetailCancelButton